// Libs
import { uniq } from 'lodash';

// Utils
import { isOverlapping } from '../../../common/maths/geometry/rect';
import { getDomElementId } from '../utils/elementUtil';

// Constants
import { BoardSections } from '../../../common/boards/boardConstants';

const isTrashMove = (location) => location.section === BoardSections.TRASH;
export const isMoveToTrash = ({ location }) => isTrashMove(location);
export const isMoveFromTrash = ({ from }) => isTrashMove(from);
export const isMoveToOrFromTrash = ({ location, from }) => isMoveToTrash({ location }) || isMoveFromTrash({ from });

// FIXME See if we can get the measurements from the measurements map instead
const getElementDOMMeasurement = (elementId) => {
    const elementDomNode = document.getElementById(getDomElementId(elementId));
    if (!elementDomNode) return null;

    return elementDomNode.getBoundingClientRect();
};

const getOverlappingElements = (move, currentBoardElements) => {
    const movedElementRect = getElementDOMMeasurement(move.id);

    return currentBoardElements.filter((el) => {
        const elementRect = getElementDOMMeasurement(el.id);
        return isOverlapping(movedElementRect, elementRect);
    });
};

export const getAllOverlappingElements = (moveGroup, currentBoardElements) =>
    moveGroup.reduce((acc, move) => {
        const overlappingElements = getOverlappingElements(move, currentBoardElements);
        return uniq(acc.concat(overlappingElements));
    }, []);
